<template>
  <div class="product-entry">
    <img :src="entry.product.photos[0].url" class="product-entry__image" />

    <div class="product-entry__info">
      <h4>{{ entry.product.name }}</h4>
      <p>{{ entry.product.description }}</p>
      <p>{{ entry.product.price | money }} chaque</p>
    </div>

    <div class="product-entry__total">
      <div class="product-entry__qty">
        <span>{{ entry.quantity }}</span>
        <a @click="addQty()" class="product-entry__qty--plus">
          <font-awesome-icon icon="plus" />
        </a>
        <a @click="minusQty()" class="product-entry__qty--minus">
          <font-awesome-icon icon="minus" />
        </a>
      </div>

      <p>{{ (entry.product.price * entry.quantity) | money }} total</p>
    </div>
    <a @click="removeProduct()" class="product-entry__close">
      <font-awesome-icon icon="times" />
    </a>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'cart-product',
    props: {
      entry: Object
    },
    data() {
      return {
        loading: false
      };
    },
    methods: {
      ...mapActions('orders', {
        upsertProduct: 'upsertProduct',
        _removeProduct: 'removeProduct'
      }),
      async minusQty() {
        if (!this.loading) {
          try {
            this.loading = true;
            await this.upsertProduct({
              productId: this.entry.product.id,
              quantity: '-'
            });
          }
          finally {
            this.loading = false;
          }
        }
      },
      async addQty() {
        if (!this.loading) {
          try {
            this.loading = true;
            await this.upsertProduct({
              productId: this.entry.product.id,
              quantity: '+'
            });
          }
          finally {
            this.loading = false;
          }
        }
      },
      async removeProduct() {
        if (!this.loading) {
          try {
            this.loading = true;
            await this._removeProduct(this.entry.product.id);
          }
          finally {
            this.loading = false;
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.product-entry {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 20px;

  p {
    margin-left: 0;
    padding-left: 0;
  }

  &__image {
    max-width: 150px;
  }

  &__info {
    padding-left: 20px;
    min-width: 300px;
  }

  &__qty {
    width: 100px;
    margin-bottom: 10px;

    a {
      margin-left: 5px;
      margin-right: 5px;
    }

    &--plus,
    &--minus {
      color: black !important;
    }
  }

  &__total {
    max-width: 100px;
  }

  &__close {
    color: black !important;
  }

  &__quantity {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
}
</style>
